import { IUserInfoDto } from '../interface/IUserInfoDto'

export const UserInfoDto: IUserInfoDto = {
  userId: '',
  platformServiceFeeCredit: 200,
  email: '',
  displayName: '',
  picture: '',
  userOrderScores: {
    positiveOrderForShop: 0,
    negativeOrderForShop: 0,
    positiveOrderForPlatform: 0,
    negativeOrderForPlatform: 0
  }
}
